<template>
    <el-collapse v-model="activeCollapse">
        <el-collapse-item :title="$t('settings.sorting')" name="sorting">
            <div>
                <BaseRadioGroup
                    v-model="order"
                    :radios="orderList"
                    class="radio-groups mb-5"
                />
            </div>
            <div>
                <base-select
                    :data="propsList"
                    :multiple="false"
                    :labelKey="'label'"
                    :valueKey="'value'"
                    v-model="prop"/>
            </div>
        </el-collapse-item>
    </el-collapse>
</template>

<script>
import startCase from "lodash/startCase";
import { getTranslationOrUndefined } from '@/helpers/translation'
import { Collapse, CollapseItem, Select, RadioGroup } from 'element-ui'

const DEFAULT_ORDER = 'ascending'
export default {
    name: "SortingParams",
    components: {
        [Collapse.name]: Collapse,
        [CollapseItem.name]: CollapseItem,
        [RadioGroup.name]: RadioGroup,
        [Select.name]: Select,
    },
    props: {
        model: {
            type: Object,
            default: () => ({}),
        },
    },
    data () {
        return {
            activeCollapse: 'sortingParams',
            prop: '',
            propsList: [],
            order: DEFAULT_ORDER,
            orderList: [
                {
                    label: this.$t('sorting.asc'),
                    value: DEFAULT_ORDER
                },
                {
                    label: this.$t('sorting.desc'),
                    value: 'descending'
                }
            ]
        }
    },
    watch: {
        prop (newV) {
            const { sortingParams } = this.model.WidgetLayout
            if (sortingParams) {
                sortingParams.prop = newV
            } else {
                this.model.WidgetLayout.sortingParams = {
                    order: this.order,
                    prop: newV
                }
            }
        },
        order (newV) {
            const { sortingParams } = this.model.WidgetLayout
            if (sortingParams) {
                sortingParams.order = newV
            } else {
                this.model.WidgetLayout.sortingParams = {
                    order: newV,
                    prop: this.prop
                }
            }
        }
    },
    methods: {
        initSortingParams () {
            try {
                const { sortingParams } = this.model.WidgetLayout
                if (sortingParams) {
                    this.prop = sortingParams.prop || ''
                    this.order = sortingParams.order || DEFAULT_ORDER
                } else {
                    this.model.WidgetLayout.sortingParams = {
                        order: DEFAULT_ORDER,
                        prop: ''
                    }
                }
                const { WidgetTemplateColumns } = this.model
                this.propsList = []
                if (WidgetTemplateColumns) {
                    WidgetTemplateColumns.forEach(column => {
                        const label = getTranslationOrUndefined(column.TemplateNameContentTag)
                            || getTranslationOrUndefined(column.WidgetTemplateColumnsName)
                            || startCase(column.WidgetTemplateColumnsName)
                        this.propsList.push({
                            label: label,
                            value: column.WidgetTemplateColumnsTag
                        })
                    })
                }
            } catch (e) {
                console.error(e)
            }
        }
    },
    mounted () {
        this.initSortingParams()
    }
}
</script>

<style scoped>

</style>